<template>
  <AlDialog
    v-model="dialog"
    title="Customer Site Access"
    subtitle="Give your customer access to view specific TAG sites"
    :error="error"
    @clearErrors="clearErrors()"
    :width="864"
  >
    <CustomerDetailSitesForm
      class="mb-4"
      :customer-id="customerId"
      ref="customerDetailSitesFormRef"
      @save="closeDialog()"
    />

    <template #actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="flat" :loading="isPending" @click="saveCustomerSites()"
        >Save</v-btn
      >
    </template>
  </AlDialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import type { ISystemError } from '@/models/error'

import AlDialog from '@/components/common/AlDialog.vue'
import CustomerDetailSitesForm from './CustomerDetailSitesForm.vue'

interface Props {
  customerId: number
}

const dialog = defineModel<boolean>('dialog', { default: false })

const props = defineProps<Props>()

const customerId = computed(() => props.customerId)

const customerDetailSitesFormRef = ref<typeof CustomerDetailSitesForm>()

const isPending = computed<boolean>(() => customerDetailSitesFormRef.value?.isPending)
const error = computed<ISystemError | null>(() => customerDetailSitesFormRef.value?.error)

function clearErrors() {
  customerDetailSitesFormRef.value?.clearErrors()
}
function saveCustomerSites() {
  return customerDetailSitesFormRef.value?.saveCustomerSites()
}

function closeDialog() {
  dialog.value = false
}
</script>

<style lang="scss">
.al-form-card {
  padding: 1rem;
}
</style>
